import Resource from '@/api/resources/Resource'

class CustomNotificationTextTemplatesService extends Resource {
    async getAllCustomNotificationTextTemplatesIncludingLaboratory(laboratoryId, type) {
        const params = { type: type, laboratoryId: laboratoryId }
        const response = await this.axios.get(`/customNotificationTextTemplates/includingLaboratory`, { params: params })
        return response.data
    }
    async getAllCustomNotificationUserTextTemplates(type) {
        const params = { type: type }
        const response = await this.axios.get(`/customNotificationTextTemplates`, { params: params })
        return response.data
    }
    async deleteCustomNotificationTextTemplateBatch(customNotificationTextTemplateIds) {
        const response = await this.axios.delete(`/customNotificationTextTemplates/batch`, { data: customNotificationTextTemplateIds })
        return response.data
    }
    async createCustomNotificationTextTemplate(createRequest) {
        const response = await this.axios.post(`/customNotificationTextTemplates`, createRequest)
        return response.data
    }
    async patchCustomNotificationTextTemplateBatch(customNotificationTextTemplatePatchInBatchRequests) {
        const response = await this.axios.patch(`/customNotificationTextTemplates/batch`, customNotificationTextTemplatePatchInBatchRequests)
        return response.data
    }
}

export default new CustomNotificationTextTemplatesService()
